module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/105-cameroon-f1dc9e690f41ad8e7897027a1d8a5869.svg";